import { z } from 'zod';

import { TopicSchema } from '../Topics';

export const InsightSchema = z
  .object({
    id: z.number().int(),
    user_id: z.number().int(),
    organization_id: z.number().int(),
    topic_id: z.number().int(),
    title: z.string(),
    expiration_date: z.iso.datetime({ offset: true }).optional().nullable(),
    text: z.string(),
    is_deleted: z.boolean(),
    is_archived: z.boolean(),
    created_at: z.iso.datetime({ offset: true }),
    updated_at: z.iso.datetime({ offset: true }),
    duration_months: z.union([z.literal(0), z.literal(3), z.literal(6), z.literal(12), z.literal(24)]),
    topic: TopicSchema,
    is_public: z.boolean(),
    user: z.object({
      user_id: z.number().int(),
      email: z.string().optional().nullable(),
      first_name: z.string().optional().nullable(),
      given_name: z.string().optional().nullable(),
      last_name: z.string().optional().nullable(),
      family_name: z.string().optional().nullable(),
      middle_name: z.string().optional().nullable(),
    }),
  })
  .transform((raw) => ({
    id: raw.id,
    userId: raw.user_id,
    organizationId: raw.organization_id,
    topicId: raw.topic_id,
    title: raw.title,
    expirationDate: raw.expiration_date,
    text: raw.text,
    isDeleted: raw.is_deleted,
    isArchived: raw.is_archived,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
    topic: raw.topic,
    durationMonths: raw.duration_months,
    isPublic: raw.is_public,
    authorGivenName: raw.user.given_name ?? raw.user.first_name,
    authorFamilyName: raw.user.family_name ?? raw.user.last_name,
    authorMiddleName: raw.user.middle_name,
  }));

export type InsightEntityApi = z.input<typeof InsightSchema>;
export type InsightEntity = z.infer<typeof InsightSchema>;
